export default "__VITE_ASSET__zd9rg6fm__"